
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { get } from 'lodash';
import { environment } from 'src/environments/environment';
import { PublicExecutiveSession, SessionMobile } from '../shared/interfaces/sessions';
import { ContextService } from './context.service';
@Injectable({
  providedIn: 'root'
})
export class SessionService {

  clientOwnershipOrserved = new Subject<string>();

  constructor(private contextService: ContextService) { }

  get userId(): string {
    return sessionStorage.getItem('userId');
  }

  set userId(userId: string) {
    sessionStorage.setItem('userId', userId);
  }

  get ipClient(): string {
    return sessionStorage.getItem('ipClient');
  }

  set ipClient(ipClient: string) {
    sessionStorage.setItem('ipClient', ipClient);
  }

  get customerIdentificationNumber(): string {
    return sessionStorage.getItem('customerIdentificationNumber');
  }
  set customerIdentificationNumber(customerIdentificationNumber: string) {
    sessionStorage.setItem('customerIdentificationNumber', customerIdentificationNumber);
  }

  public get accountNames(): string {
    return sessionStorage.getItem('accountNames');
  }

  public set accountNames(value: string) {
    sessionStorage.setItem('accountNames', value);
  }

  get customerFirstName(): string {
    return sessionStorage.getItem('customerFirstName');
  }
  set customerFirstName(customerFirstName: string) {
    sessionStorage.setItem('customerFirstName', customerFirstName);
  }

  get customerAddress(): string {
    return sessionStorage.getItem('customerAddress');
  }
  set customerAddress(value) {
    sessionStorage.setItem('customerAddress', JSON.stringify(value));
  }

  get customerEmails(): string {
    return sessionStorage.getItem('customerEmails');
  }
  set customerEmails(value) {
    sessionStorage.setItem('customerEmails', JSON.stringify(value));
  }

  get customerLastName(): string {
    return sessionStorage.getItem('customerLastName');
  }
  set customerLastName(customerLastName: string) {
    sessionStorage.setItem('customerLastName', customerLastName);
  }
  public get customerIdentificationType(): string {
    return sessionStorage.getItem('customerIdentificationType');
  }
  public set customerIdentificationType(value: string) {
    sessionStorage.setItem('customerIdentificationType', value);
  }

  public get client(): string {
    return sessionStorage.getItem('client');
  }
  public set client(value: string) {
    sessionStorage.setItem('client', value.toString());
  }

  public get executiveUserName(): string {
    return sessionStorage.getItem('username');
  }
  public set executiveUserName(value: string) {
    sessionStorage.setItem('username', value);
  }

  public get executiveFirstName(): string {
    return sessionStorage.getItem('firstName');
  }
  public set executiveFirstName(value: string) {
    sessionStorage.setItem('firstName', value);
  }

  public get executiveLastName(): string {
    if (sessionStorage.getItem('lastName') != null) {
      return sessionStorage.getItem('lastName');
    } else {
      return '';
    }
  }
  public set executiveLastName(value: string) {
    sessionStorage.setItem('lastName', value);
  }

  public get executiveOfficeName(): string {
    return sessionStorage.getItem('officeName');
  }
  public set executiveOfficeName(value: string) {
    sessionStorage.setItem('officeName', value);
  }

  public get executiveOfficeId(): string {
    return sessionStorage.getItem('officeId');
  }
  public set executiveOfficeId(value: string) {
    sessionStorage.setItem('officeId', value.toString());
  }

  public get executivePositionName(): string {
    return sessionStorage.getItem('positionName');
  }
  public set executivePositionName(value: string) {
    sessionStorage.setItem('positionName', value);
  }

  public get executiveEmailAddress(): string {
    return sessionStorage.getItem('emailAddress');
  }
  public set executiveEmailAddress(value: string) {
    sessionStorage.setItem('emailAddress', value);
  }

  public setItem(key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  public clearSession() {
    if (environment.mode !== 'WEB-PF' && environment.mode !== 'PF' && !this.contextService.isMobile()) {
      localStorage.clear();
    }
    if (environment.isWc) {
      sessionStorage.removeItem('accountType');
      sessionStorage.removeItem('session_platform');
    } else {
      sessionStorage.clear();
    }
  }

  public get executiveCode(): string {
    return sessionStorage.getItem('executiveCode');
  }
  public set executiveCode(value: string) {
    sessionStorage.setItem('executiveCode', value);
  }

  public get isCallCenter(): string {
    return sessionStorage.getItem('isCallCenter');
  }
  public set isCallCenter(value: string) {
    sessionStorage.setItem('isCallCenter', value);
  }
  public get clientOwnership(): string {
    return sessionStorage.getItem('titularidadCliente');
  }

  public set clientOwnership(value: string) {
    this.clientOwnershipOrserved.next(value);
    sessionStorage.setItem('titularidadCliente', value);
  }

  public saveExecutiveData(executiveResponse: any) {
    this.executiveFirstName = get(executiveResponse, 'generic.firstName', '');
    this.executiveLastName = get(executiveResponse, 'generic.lastName', '');
    this.executiveEmailAddress = get(executiveResponse, 'generic.emailAddress', '');
    this.executiveOfficeName = get(executiveResponse, 'generic.officeName', '');
    this.executivePositionName = get(executiveResponse, 'generic.positionName', '');
    this.executiveUserName = this.executiveEmailAddress;
  }

  public get keepAlive(): number {
    return +sessionStorage.getItem('keep_alive');
  }

  public set keepAlive(value: number) {
    sessionStorage.setItem('keep_alive', value.toString());
  }

  public get sessionAccountType(): string {
    return sessionStorage.getItem('accountType');
  }

  public set sessionAccountType(value: string) {
    sessionStorage.setItem('accountType', value.toString());
  }

  public get sessionExecutiveHashId(): string {
    return sessionStorage.getItem('session_executive_hash_id');
  }

  public set sessionExecutiveHashId(value: string) {
    sessionStorage.setItem('session_executive_hash_id', value.toString());
  }

  public get sessionHashId(): string {
    return sessionStorage.getItem('session_hash_id');
  }

  public set sessionHashId(value: string) {
    sessionStorage.setItem('session_hash_id', value.toString());
  }

  public get sessionBody(): string {
    return sessionStorage.getItem('session_body');
  }

  public set sessionBody(value: string) {
    sessionStorage.setItem('session_body', value.toString());
  }

  public get sessionPlatform(): string {
    return sessionStorage.getItem('session_platform');
  }

  public set sessionPlatform(value: string) {
    sessionStorage.setItem('session_platform', value.toString());
  }

  public get accessToken(): string {
    return sessionStorage.getItem('access_token');
  }

  public set accessToken(value: string) {
    sessionStorage.setItem('access_token', value);
  }

  public get isJointAccount(): string {
    return sessionStorage.getItem('is_joint_account');
  }

  public set isJointAccount(value: string) {
    sessionStorage.setItem('is_joint_account', value);
  }

  public get refreshToken(): string {
    return sessionStorage.getItem('refresh_token');
  }
  public set refreshToken(value: string) {
    sessionStorage.setItem('refresh_token', value);
  }

  public get expiresIn(): number {
    return +sessionStorage.getItem('expires_in');
  }
  public set expiresIn(value: number) {
    sessionStorage.setItem('expires_in', value.toString());
  }

  public get tokenType(): string {
    return sessionStorage.getItem('token_type');
  }
  public set tokenType(value: string) {
    sessionStorage.setItem('token_type', value);
  }

  public get dateToken(): number {
    return +sessionStorage.getItem('date_token');
  }
  public set dateToken(value: number) {
    sessionStorage.setItem('date_token', value.toString());
  }
  public get dateLastUpdate(): number {
    return +sessionStorage.getItem('date_last_update');
  }
  public set dateLastUpdate(value: number) {
    sessionStorage.setItem('date_last_update', value.toString());
  }

  public get mobilePlatform(): string {
    return sessionStorage.getItem('mobile_platform');
  }
  public set mobilePlatform(value: string) {
    sessionStorage.setItem('mobile_platform', value.toString());
  }

  public setPublicClientSession(accountType: string) {
    this.sessionAccountType = accountType;
  }

  public setPublicExecutiveSession(sessionInfo: PublicExecutiveSession) {
    this.sessionPlatform = sessionInfo.sessionPlatform;
    this.sessionAccountType = sessionInfo.accountType;
    this.executiveCode = sessionInfo.executiveCode;
    this.executiveEmailAddress = sessionInfo.executiveEmailAddress;
    this.executiveFirstName = sessionInfo.executiveFirstName;
    this.executiveLastName = sessionInfo.executiveLastName;
    this.executiveOfficeId = sessionInfo.executiveOfficeId;
    this.executiveUserName = sessionInfo.executiveUserName;
    this.isCallCenter = sessionInfo.isCallCenter;
  }

  public setMobileSession(sessionInfo: SessionMobile, accountType) {
    this.sessionAccountType = accountType;
    this.sessionPlatform = 'IN';
    this.accessToken = sessionInfo.accessToken;
    this.mobilePlatform = sessionInfo.mobilePlatform;
    this.customerIdentificationNumber = sessionInfo.customerIdentificationNumber;
    this.customerIdentificationType = sessionInfo.customerIdentificationType;
    this.isJointAccount = sessionInfo.isJointAccount ? sessionInfo.isJointAccount : '0';
  }

  public setDrawScript(draw: string) {
    sessionStorage.setItem('drawScript', draw);
  }

  public get drawScript(): string {
    return sessionStorage.getItem('drawScript');
  }

  public setIntention(value: string) {
    sessionStorage.setItem('intention', value);
  }

  public get intention(): string {
    return sessionStorage.getItem('intention');
  }

  public getRequestHeaders() {
    // Defaults for any mode
    const headers: RequestHeaders = {
      accountType: this.sessionAccountType,
      customerIdentificationNumber: this.customerIdentificationNumber,
      customerIdentificationType: this.customerIdentificationType
    };
    if (!this.contextService.isPublicOmni1()) {
      headers.sessionPlatform = this.sessionPlatform;
    }
    if (this.contextService.isPrivateOmni1()) {
      headers.Authorization = `Bearer ${this.accessToken}`;
    } else if (this.contextService.isExecutiveMode()) {
      headers.executiveCode = this.executiveCode;
      headers.executiveEmailAddress = this.executiveEmailAddress;
      headers.executiveFirstName = this.executiveFirstName;
      headers.executiveLastName = this.executiveLastName;
      headers.executiveOfficeId = this.executiveOfficeId;
      headers.executiveUserName = this.executiveUserName;
      headers.isCallCenter = this.isCallCenter;
    }
    return headers;
  }

  public getAditionalPageInfoForAnalytics(): InfoAnalytics {
    const aditionalPageInfo: InfoAnalytics = {
      channel: 'WEB',
      intention: this.intention
    };

    if (this.contextService.isMobile() && this.contextService.getMode() === 'IN') {
      aditionalPageInfo.channel = 'APP';
    }
    if (this.contextService.isWC() && this.contextService.getMode() === 'IN') {
      aditionalPageInfo.channel = 'OMNI1';
    }
    if (this.contextService.isWC() && this.contextService.getMode() === 'PF') {
      aditionalPageInfo.channel = 'OMNI2';
    }
    return aditionalPageInfo;
  }
}

interface RequestHeaders {
  accountType: string;
  customerIdentificationNumber: string;
  customerIdentificationType: string;
  sessionPlatform?: string;
  Authorization?: string;
  executiveCode?: string;
  executiveEmailAddress?: string;
  executiveFirstName?: string;
  executiveLastName?: string;
  executiveOfficeId?: string;
  executiveUserName?: string;
  isCallCenter?: string;
}

interface InfoAnalytics {
  channel?: string;
  intention?: string;
}
